import { Component, Input, OnChanges, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TableColumn } from '@swimlane/ngx-datatable';
import { Actions } from 'src/app/models';
import { GridSettings } from 'src/app/models/grid-settings';
import { PublishHistory, SecurityService, WorkflowService } from 'src/app/services';

@Component({
    selector: 'wm-workflow-publish-history',
    templateUrl: './workflow-publish-history.component.html',
    styleUrl: './workflow-publish-history.component.css',
    standalone: false
})
export class WorkflowPublishHistoryComponent implements OnInit, OnChanges {
  @Input() workflowId: string;
  @ViewChild('viewVersionTmpl', { static: true }) viewVersionTmpl: TemplateRef<any>;
  isGlobalAdmin: boolean;

  ngOnChanges(): void {
    this.getPublishHistory();
  }

  publishColumns: TableColumn[] = [
    { prop: 'lastPublishedBy', name: 'Published By' },
    { prop: 'lastPublishedOnString', name: 'Published On' },
    { prop: 'reason', name: 'Reason' }
  ];
  publishRows: PublishHistory[] = null;
  publishPage: number = 0;
  publishPageSize: number = 5;
  publishTotal: number;
  publishLoading: boolean = false;

  constructor(private workflowService: WorkflowService, private _securitySvc: SecurityService) { }

  ngOnInit() {
    this._securitySvc.isLoginEntitled(Actions.DO_ANYTHING).subscribe(result => {
      this.isGlobalAdmin = result;

      if (this.isGlobalAdmin) {
        this.publishColumns.push({
          prop: 'workflowVersionId',
          name: 'Version',
          cellTemplate: this.viewVersionTmpl
        })
      }

      this.getPublishHistory();
    });
  }

  getPublishHistory() {
    this.publishLoading = true;
    this.workflowService.getPublishHistory(this.workflowId, this.publishPage, this.publishPageSize)
      .subscribe(results => {
        this.publishTotal = results.totalCount;
        this.publishRows = results.history;
        this.publishLoading = false;
      });
  }

  publishSettingsChanged(settings: GridSettings) {
    this.publishPageSize = settings.pageSize;
    this.publishPage = settings.pageNumber;
    this.getPublishHistory();
  }

}
